import { render, staticRenderFns } from "./DynamicFormTest.vue?vue&type=template&id=520f9ef4&"
import script from "./DynamicFormTest.vue?vue&type=script&lang=js&"
export * from "./DynamicFormTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports